module.exports = __webpack_public_path__ + "static/img/account.0896276.svg";